import { AppError } from "../common/app-error";

export class BadInput extends AppError {}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/pages/common/bad-input.ts